import React from "react"

import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import FieldProto from "../../../../proto/field-proto"
import {ConditionType} from "../../../../../model2/conditions/condition-types"
import FieldsFactory from "../../../../fields-factory"
import {FieldType} from "../../../../field-type"
import FieldFormElementView from "../../../../render/form-elemnent-view"
import EditableInput from "../../../string/render/inline-editable/input-component";

const debug = false
// const debug = "FieldCurrency_ConditionForm"

export default class FieldCurrency_ConditionForm extends FieldProto_ConditionForm {

    onChangeConditionType = (type: ConditionType)=> {

        if (type !== ConditionType.NUMBER_BETWEEN) {
            this.onChangeValue(null)
        }

        this.onChangeType(type)
    }

    onChangeConditionValue = (newValue: string)=> {
        this.onChangeValue(newValue)
    }

    onChangeGreatThanValue = (newValue: string)=> {
        const value = {...this.props.condition.value, greaterThan: newValue}
        this.onChangeValue(value)
    }

    onChangeLessThanValue = (newValue: string)=> {
        const value = {...this.props.condition.value, lessThan: newValue}
        this.onChangeValue(value)
    }

    renderConditionForm = (field: FieldProto)=> {
        switch (this.props.condition.type) {
            case ConditionType.NUMBER_BETWEEN:
                return (
                    <div className="flex-row-left-top w-250 m-l-10">
                        <EditableInput className        = "ui5-txt-default ui5-field-form-editable w-140 h-36 p-l-10 p-r-10"
                                       inputClassName   = "ui5-txt-default"
                                       placeholder      = "Min value"
                                       type             = "number"
                                       value            = {this.props.condition.value?.greaterThan}
                                       onChange         = {this.onChangeGreatThanValue}/>
                        <div className="ui5-txt-not-important-small h-36 fl-ac m-r-5 m-l-5">-</div>
                        <EditableInput className        = "ui5-txt-default ui5-field-form-editable w-140 h-36 p-l-10 p-r-10"
                                       inputClassName   = "ui5-txt-default"
                                       placeholder      = "Max value"
                                       type             = "number"
                                       value            = {this.props.condition.value?.lessThan}
                                       onChange         = {this.onChangeLessThanValue}/>
                    </div>
                )
            case ConditionType.NUMBER_LESS_THAN:
            case ConditionType.NUMBER_GREATER_THAN:
            case ConditionType.NUMBER_EQUALS:
            default:
                return (
                    <div className="flex-row-left-center m-l-10">
                        <FieldFormElementView className = "w-250 flex-no-shrink"
                                              field     = {field}
                                              model     = {{value: this.props.condition.value}}
                                              onChange  = {this.onChangeConditionValue}/>
                    </div>
                )
        }
    }

    render() {
        let field: FieldProto | null | false = null

        switch (this.props.condition.type) {
            case ConditionType.NUMBER_LESS_THAN:
            case ConditionType.NUMBER_GREATER_THAN:
            case ConditionType.NUMBER_EQUALS:
            case ConditionType.NUMBER_BETWEEN:
                field = FieldsFactory.get({
                    type    : FieldType.NUMBER,
                    fieldId : 'value'
                })
                break


            default:
                break

        }

        debug && console.log(debug, 'render', field)

        return (
            <>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeConditionType}/>

                {field && this.renderConditionForm(field)}
            </>
        )
    }
}
